"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./Label.module.css"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Label = (function (_super) {
    __extends(Label, _super);
    function Label(props) {
        var _this = _super.call(this, props) || this;
        _this.helpVisible = false;
        return _this;
    }
    Label.prototype.render = function () {
        var _a = this.props, error = _a.error, help = _a.help, text = _a.text, required = _a.required, htmlFor = _a.htmlFor, hint = _a.hint;
        return (React.createElement("div", null,
            React.createElement("label", { className: styles.root, htmlFor: htmlFor },
                text,
                required && React.createElement("span", null, "*"),
                " ",
                hint && (React.createElement("span", { style: { color: "black" } },
                    React.createElement("small", null,
                        React.createElement("i", null, hint)))),
                help && React.createElement("small", { style: { display: "block" } }, help)),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    __decorate([
        mobx_1.observable
    ], Label.prototype, "helpVisible", void 0);
    Label = __decorate([
        mobx_react_1.observer
    ], Label);
    return Label;
}(react_1.Component));
exports.Label = Label;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0xhYmVsL0xhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUMvQix5REFBNEM7QUFDNUMseUNBQW1DO0FBQ25DLDZCQUErQjtBQVkvQjtJQUEyQix5QkFBeUI7SUFJaEQsZUFBWSxLQUFLO1FBQWpCLFlBQ0ksa0JBQU0sS0FBSyxDQUFDLFNBQ2Y7UUFKTyxpQkFBVyxHQUFHLEtBQUssQ0FBQTs7SUFJM0IsQ0FBQztJQUNNLHNCQUFNLEdBQWI7UUFDVSxJQUFBLGVBQXlELEVBQXhELGdCQUFLLEVBQUUsY0FBSSxFQUFFLGNBQUksRUFBRSxzQkFBUSxFQUFFLG9CQUFPLEVBQUUsY0FBa0IsQ0FBQTtRQUUvRCxPQUFPLENBQ0g7WUFDSSwrQkFBTyxTQUFTLEVBQUUsTUFBTSxDQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTztnQkFDMUMsSUFBSTtnQkFDSixRQUFRLElBQUksc0NBQWM7Z0JBQUUsR0FBRztnQkFDL0IsSUFBSSxJQUFJLENBQ0wsOEJBQU0sS0FBSyxFQUFFLEVBQUMsS0FBSyxFQUFFLE9BQU8sRUFBQztvQkFDekI7d0JBQ0ksK0JBQUksSUFBSSxDQUFLLENBQ1QsQ0FDTCxDQUNWO2dCQUNBLElBQUksSUFBSSwrQkFBTyxLQUFLLEVBQUUsRUFBQyxPQUFPLEVBQUUsT0FBTyxFQUFDLElBQUcsSUFBSSxDQUFTLENBQ3JEO1lBQ1AsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ2hELENBQ1QsQ0FBQTtJQUNMLENBQUM7SUF6QkQ7UUFEQyxpQkFBVTs4Q0FDZ0I7SUFGbEIsS0FBSztRQURqQixxQkFBUTtPQUNJLEtBQUssQ0E0QmpCO0lBQUQsWUFBQztDQUFBLEFBNUJELENBQTJCLGlCQUFTLEdBNEJuQztBQTVCWSxzQkFBSyJ9